import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import i18next from "i18next";

class SubVacation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            reportErrorMessage: ""
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true, withStyle: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-md-2">
                    {h.lbl("NumYear")}
                </div>
                <div className="col-md-2">
                    {h.ed("NumYear")}
                </div>

                <div className="col-md-2">
                    {h.lbl("NumMonthView")}
                </div>
                <div className="col-md-2">
                    {h.ed("NumMonthView")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-8">
                    {h.ed("IsDekretMsg")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-4">
                    {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                    {h.lbl("NumSub")}
                </div>
                <div className="col-md-1">
                    {h.ed("NumSub")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-12">
                    {h.ed("AdmStructName")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-4">
                    {i18next.t("SubordinateSearch")}:
                </div>
                <div className="col-md-8" style={{height: "32px"}}>
                    <SearchBar dataItem={this.props.listSubForPO}/>
                </div>
            </div>
        </>);
    };

    getTabNumArr = () => {
        return this.props.listSubForPO.dataTable().map(r => ({TabNum: r.TabNum}));
    };

    renderReportParams = (h) => {
        return (<div className="row">
            <div className="col-md-2">
                {h.lbl("DateShow")}
            </div>
            <div className="col-md-3">
                {h.ed("DateShow")}
            </div>
        </div>);
    };

    renderReports = () => {
        return (<>
            <PlaceholderWrapper placeholderId="40"
                                title={<><i className='fa fa-table'/> {i18next.t("Reports")}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ReportPlaceholder reportKey="KP_LstHldNotUse" reportId="KP_LstHldNotUse" title={i18next.t("SubVacation_Report_UnusedVacations")}>
                    {(reportParamsItem, build) => {
                        this.reportParamsNotUsedVacation = reportParamsItem;
                        return (<>
                            <ComplexParam dataItem={reportParamsItem}
                                          readOnly={false}
                                          showSearchBar={false}
                                          showApplyButton={false}
                                          autoApplyParams={false}
                                          rootPath="/"
                                          renderParams={this.renderReportParams}
                            />
                            <button className="btn mn-btn-link" onClick={async (e) => {
                                e.preventDefault();

                                let dateShow = reportParamsItem.getField(0, "DateShow");
                                if (!dateShow) {
                                    this.setState({reportErrorMessage: i18next.t("SubVacation_Report_SelectDate")});
                                    return;
                                }

                                await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", this.getTabNumArr()));

                                await build();
                            }}>
                                {i18next.t("SubVacation_Report_UnusedVacations")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                <br/>
                {/*{this.props.workplaceType !== WorkplaceTypes.Slavutich &&*/}
                <ReportPlaceholder reportKey="KP_HldReserve" reportId="KP_HldReserve" title={i18next.t("SubVacation_Report_ReserveVacations")}>
                    {(reportParamsItem, build) => {
                        return (<>
                            <button className="btn mn-btn-link" onClick={async (e) => {
                                e.preventDefault();

                                let dateShow = this.reportParamsNotUsedVacation.getField(0, "DateShow");
                                if (!dateShow) {
                                    this.setState({reportErrorMessage: i18next.t("SubVacation_Report_SelectDate")});
                                    return;
                                }

                                await this.props.dispatch(reportParamsItem.setField(0, "DateShow", dateShow));
                                await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", this.getTabNumArr()));

                                await build();
                            }}>
                                {i18next.t("SubVacation_Report_ReserveVacations")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                {/*}*/}
            </PlaceholderWrapper>

            <MessageBox title={i18next.t("ReportBuilding")}
                        messageText={this.state.reportErrorMessage}
                        visible={!!this.state.reportErrorMessage}
                        onClose={() => {
                            this.setState({reportErrorMessage: ""})
                        }}
            />
        </>);
    }

    gridContentContainerStyleProvider = ({mobileMode}) => {
        if (!mobileMode) {
            //let height = window.innerHeight;
            let height = 500;
            return {
                minHeight: "150px", height: height + "px"
            };
        }
    }

    render() {
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubVacation_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<PlaceholderWrapper placeholderId="10" title={i18next.t("SubVacation_Title")} canCollapse={false}
                                    showSplitterLine={false}>
            {this.renderReports()}

            <PlaceholderWrapper placeholderId="20"
                                title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                showSplitterLine={false}
                                canCollapse={false}>
                <ComplexParam dataItem={this.props.listSubForPOParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.listSubForPO}
                              renderParams={this.renderParam}
                />
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="30"
                                title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                staticTitle={i18next.t('SubVacation_GridTitle')}
                                showSplitterLine={false}
                                canCollapse={false}>
                <GridView dataItem={this.props.listSubForPO} useItemStyle={true} fixHeader={true}
                          contentContainerStyleProvider={this.gridContentContainerStyleProvider}/>
            </PlaceholderWrapper>
        </PlaceholderWrapper>);
    }
}

SubVacation.propTypes = {
    dispatch: PropTypes.func.isRequired, listSubForPO: PropTypes.object, listSubForPOParams: PropTypes.object,
    workplaceType: PropTypes.string
};

SubVacation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.subVacationState.EmployeesVacation_ListSubForPO,
        listSubForPOParams: state.subVacationState.EmployeesVacation_ListSubForPOParams,
        workplaceType: state.appState.appParams.workplaceType
    }
}

export default connect(mapStateToProps)(SubVacation);